import { HelpersService } from './../../services/tools/helpers.service';
import { InversionistasService } from './../../services/inversionistas.service';
import { ValidatorService } from '../../services/tools/validator.service';
import { ObrasService } from '../../services/obras.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SuccessModalComponent } from '../tools/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from '../tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from '../tools/modals/confirm-modal/confirm-modal.component';
import {Globals} from './../../services/tools/Globals.service';
declare var $;


@Component({
  selector: 'app-catalogo-inversionistas',
  templateUrl: './catalogo-inversionistas.component.html',
  styleUrls: ['./catalogo-inversionistas.component.scss']
})
export class CatalogoInversionistasComponent implements OnInit {

  @ViewChild(SuccessModalComponent) successModal: SuccessModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;

  inversionistas:any[];
  searchText:string = "";
  inversionistaSelected:any;
  mostrarListado:boolean = true;
  errors:any = {};
  searchProcess:any;
  paginate:any = {};
  filterByInversionista:any;
  currentPage = 1;
  lastPage = 1;
  processing:any = false;
  alterTable:any = 'starting';
  exporting: any = false;

  page: number = 1;
  pageSize: number = 10;
  pageAll: number = 100;

  constructor(private inversionistasService: InversionistasService, private obrasService: ObrasService, private validatorService: ValidatorService, private helperService: HelpersService,
                private globals: Globals){
    // se colocó esto para que el this dentro de delete sea el del scope global
    this.getInversionistas();
    this.resetInversionistaSelected = this.resetInversionistaSelected.bind(this);
   }

  ngOnInit() {
    this.globals.passwordActivate = false;
  }

  pageChanged(event: any): void {
    if(event.page !== undefined)
      if(event.page != this.page)
      {  
        this.page = event.page;
      }
    this.goPage(this.page);
  }
  
  filtrarInversionistas(){
    this.goPage(1);

  }

  resetInversionistaSelected(){
    this.inversionistaSelected = undefined;
    this.errors = {};
  }

  startInversionistaSelected(){
    this.resetInversionistaSelected();
    this.inversionistaSelected = this.inversionistasService.getDefaultSchedule();
  }

  selectInversionista(inversionista){
    this.resetInversionistaSelected();
    const inversionistCloned = JSON.parse(JSON.stringify( inversionista ));
    this.inversionistaSelected = inversionistCloned;
  }

  SelectedInversionistaClass(inversionista) {
    return (this.validatorService.required(this.inversionistaSelected) &&  this.inversionistaSelected.idInversionistas == inversionista.idInversionistas)?"active":"";
  }

  searchInversionistas(page = null){
    if (this.searchProcess){
      this.searchProcess.unsubscribe();
    }

    if (this.searchText.length > 1){
      this.searchProcess = this.inversionistasService.searchInversionistas(this.searchText, page)
          .subscribe(response => {
            const content = response.json().content;
            this.inversionistas = content.data;
            this.startPaginate(content);
            this.searchProcess = false;
            this.alterTable = (this.inversionistas.length > 0)? false: 'not_found';
          }, error => {
            // se resuelven los errores 403 y 500
            this.helperService.httpGlobalError(error, false);
          });
    } else {
      this.getInversionistas();
    }
  }

  getInversionistas(page = null){

    this.searchProcess = this.inversionistasService.getInversionistas(page)
      .subscribe(response => {
        const content = response.json().content;
        this.inversionistas = content.data;
        this.startPaginate(content);
        this.alterTable = (this.inversionistas.length > 0)? false: 'not_result';
      }, error => {
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }
  createInversionista() {
    this.errors = [];
    this.errors = this.inversionistasService.validateInversionista(this.inversionistaSelected);
    if(!$.isEmptyObject(this.errors)){
      return false;
    }

    this.processing = true;
    this.inversionistaSelected.activa = (this.inversionistaSelected.activa)?1:0;
    this.inversionistaSelected.fechaInicio = $('#fechaInicio').val();

    this.inversionistasService.createInversionista(this.inversionistaSelected)
      .subscribe(response => {
        const respuesta = response.json();
        this.processing = false;
        if (respuesta.success) {
          this.successModal.open({
            'title': '¡Éxito!',
            'description': 'Se ha creado correctamente el inversionista'
          });
          this.inversionistaSelected.idInversionistas = respuesta.content.id;
          this.goPage(1);
        }
      }, error => {
        this.processing = false;

        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error, false);

        if (error.status == 400) {
          this.setBackendErrors(error.json().content);
        }

        if (error.status == 400 || error.status == 500) {
          this.errorModal.open({
            'title': 'Error!',
            'description': 'No se ha podido guardar el inversionista, inténtelo más tarde'
          });
        }

      });
  }

  updateInversionista() {
    this.errors = [];
    this.errors = this.inversionistasService.validateInversionista(this.inversionistaSelected)
    if (!$.isEmptyObject(this.errors)){
      return false;
    }

    this.processing = true;
    this.inversionistaSelected.activa = (this.inversionistaSelected.activa)?1:0;
    this.inversionistaSelected.fechaInicio = $('#fechaInicio').val();

    this.inversionistasService.updateInversionista(this.inversionistaSelected, this.inversionistaSelected.idInversionistas)
      .subscribe(response => {
        this.processing = false;
        if (response.json().success) {
          this.helperService.notification('¡Éxito!', 'Se ha editado correctamente el inversionista', 'success');
          this.goPage(this.currentPage);
        }
      }, error => {
        this.processing = false;
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error);

        if (error.status == 400) {
          this.setBackendErrors(error.json().content);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde', 'error');
        } 
      });
  }

  setBackendErrors(errors:any[]){
    let temp_errors = [];
    
    Object.keys(errors).forEach(function(key){
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  inversionistaSelectedWithId(){
    if(! this.inversionistaSelected)
      return false;

    return (this.validatorService.required(this.inversionistaSelected.idInversionistas));
  }

  cancelarInversionistaSelected() {
    this.confirmModal.open({
      'title': 'Cancelar Cambios',
      'description': '¿Está seguro que desea cancelar estos cambios?',
      'callback': this.resetInversionistaSelected
    });
  }

  writePermission() {
    return this.inversionistasService.writePermission();
  }

  canExport() {
    return this.inversionistasService.canExport();
  }

  export() {
    this.exporting = true;
    this.inversionistasService.export(this.searchText)
      .subscribe((response) => {
        this.exporting = false;
      }, error => {
        this.exporting = false;
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error);
      });
  }

  // MODAL FUNCTIONS

  modalCallback(callback){
    callback();
  }

  // MAIN SECTIONS FUNCTIONS 

  mainContainerClass(){
    return (this.mostrarListado)?"col-12":"offset-2 col-8";
  }

  mainTableClass(){
    return (this.mostrarListado)?"col-8":"col-4";
  }

  mainDetailsClass(){
    return (this.mostrarListado)?"col-4":"col-8";
  }

  startPaginate(content){
    this.paginate.first_item = content.from;
    this.paginate.last_item = content.to;
    this.paginate.last_page = content.last_page;
    this.paginate.per_page = content.per_page;
    this.paginate.total_items = content.total;
    this.paginate.current_page = content.current_page;
    this.currentPage = content.current_page;
    this.lastPage = content.last_page;

    this.paginate.pages = [];
    for(let i = 1; i <= this.paginate.last_page; i++){
      this.paginate.pages.push({
        'number': i,
        'label': i
      });
    }
    this.pageAll = content.total;
    this.pageSize = content.per_page;
  }

  goPreviousPage(){
    this.goPage(this.paginate.current_page - 1)
  }

  goNextPage(){
    this.goPage(this.paginate.current_page + 1);
  }

  goPage(page) {

    if (this.searchText) {
      this.searchInversionistas(page);
    } else {
      this.getInversionistas(page);
    }

  }

  changeSwitchListado(){
    if(!this.mostrarListado){
      this.inversionistaSelected = this.inversionistasService.getDefaultSchedule();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/catalogo-inversionistas/catalogo-inversionistas.component.ts